import {Axios} from '@galilee/sdk-core';
import {getAuthorizationJwtHeader} from '@common/helpers/api/apiHelper';
import {StsCredentials} from '@common/types/aws/aws.types';
import {CONTENT_TYPE_JSON} from '@common/constants/api/apiConstants';
import {JwtScope} from '@common/types/authentication/authentication.types';

export const apiAuthenticate = (baseUrl: string) => {
  const {search, pathname} = window.location;
  window.location.replace(`${baseUrl}/auth/oidc/login?originUrl=${pathname}${encodeURIComponent(search)}`);
};

export const apiRefreshJwt = async (baseUrl: string, credentials: StsCredentials, mainJwt: string) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new Axios().withUrl(baseUrl).withAwsCredentials(credentials).withHeaders(getAuthorizationJwtHeader(mainJwt)).withPathsUrl('auth', 'jwt', 'refresh').get() as Promise<any>;

export const apiBuildScopedJwt = async (baseUrl: string, credentials: StsCredentials, mainJwt: string, data: JwtScope) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new Axios<any, JwtScope>()
    .withUrl(baseUrl)
    .withAwsRegion()
    .withAwsService()
    .withAwsCredentials(credentials)
    .withHeaders({...getAuthorizationJwtHeader(mainJwt), 'Content-Type': CONTENT_TYPE_JSON})
    .withPathsUrl('auth', 'jwt', 'generate')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .post(data) as Promise<any>;
